import React, { memo, useEffect } from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption'

import { useBoolean } from '@guidde-co/shared.hooks.use-boolean'

export type CaptionsProps = {
    videoElement: HTMLVideoElement | null
    initialState?: boolean
    onClick?: () => void
}

export const Captions = memo(
    ({ videoElement, onClick, initialState = true }: CaptionsProps) => {
        const activeCC = useBoolean(initialState)

        // I think it's a temporary change, and this code will be restored.
        // I don't want to remove this code because when it will happen will be much
        // quicker to uncomment it

        /*     const hasCaptions = useBoolean()
    const setHasCaptions = hasCaptions.setTrue

    useEffect(() => {
        if (!videoElement) return
        const handleLoadCues = (e: Event) => {
            const hasCC = Boolean(
                (e.target as HTMLVideoElement)?.textTracks?.[0]?.cues?.length
            )
            if (hasCC) setHasCaptions()
        }

        videoElement.addEventListener('loadeddata', handleLoadCues)
        return () => {
            videoElement.removeEventListener('loadeddata', handleLoadCues)
        }
    }, [videoElement, setHasCaptions])

    if (hasCaptions.isFalse) return null */

        return (
            <Tooltip title={`${activeCC.isTrue ? 'Hide' : 'Show'} subtitles`}>
                <ClosedCaptionIcon
                    opacity={activeCC.isTrue ? 1 : 0.5}
                    cursor="pointer"
                    onClick={() => {
                        activeCC.toggle()
                        onClick?.()
                        if (videoElement?.textTracks[0]) {
                            videoElement.textTracks[0].mode = activeCC.isTrue
                                ? 'hidden'
                                : 'showing'
                        }
                    }}
                />
            </Tooltip>
        )
    }
)
